module.exports = __webpack_public_path__ + "img/icon-search.59144943.svg";